import { useState, useEffect, useContext } from 'react'
import { Layout } from "../../componentsV1/layout";
import Logo from "../../assets/v1/logo.png";
import { Antibody, Stack, Graph, Target, Validation } from "../../assets/v1/icons";
import css from './product.module.scss'
import { AuthContext } from '../../context/auth'
import { getProductReleaseApi, getProductFromListApi, getProductCategorysByIdApi } from '../../api'
import { useNavigate } from 'react-router-dom'
import MethodologyModal from "../../componentsV1/modals/MethodologyModal"
import { ProductList } from '../../componentsV1/ProductList'
import { ProductDetails } from '../../componentsV1/ProductDetails';

export const ProductRelease = () => {
    const { setIsLoading, setNotification, setCartData, isLoading, setUpcomingPurchaseModal, setBulkOrderModal, tempDisable, setTempDisable, width } = useContext(AuthContext)
    const navigate = useNavigate()
    const [products, setProducts] = useState({
        primary: [],
        primaryConjugates: [],
        secondary: []
    })
    const [openMethodologyModal, setOpenMethodologyModal] = useState(false)
    const [productId, setProductId] = useState(null)
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [modalName, setModalName] = useState(null)
    const [activeTab, setActiveTab] = useState('primary')

    const tabs = [
        {
            label: 'Primary Antibodies',
            value: 'primary'
        },
        {
            label: 'Conjugated Primary Antibodies',
            value: 'primaryConjugates'
        },
        {
            label: 'Secondary Fluorescent Antibodies',
            value: 'secondary'
        }
    ]

    const getProducts = async () => {
        try {
            getProductReleaseApi().then(res => {
                if (res && res.data) {
                    const primary = res?.data?.products?.filter(item => !['DC', 'SA'].includes(item?.mid_code))
                    const primaryConjugates = res?.data?.products?.filter(item => item?.mid_code === 'DC')
                    const secondary = res?.data?.products?.filter(item => item?.mid_code === 'SA')
                    setProducts({
                        primary,
                        primaryConjugates,
                        secondary
                    })
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getProducts()
    }, [])

   const getProductByIdApi = async (id) => {
        try {
            getProductFromListApi(productId?.id).then(res => {
                if (res && res.data) {
                    const product = res?.data?.products[0]
                    setSelectedProduct(product)
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (productId) {
            getProductByIdApi()
        }
    }, [productId])

    const logos = [
        {
            icon: Target,
            text: "Resolution Aware"
        },
        {
            icon: Stack,
            text: "Systematic Progression"
        },
        {
            icon: Validation,
            text: "Biologically Validated"
        },
        {
            icon: Graph,
            text: "Reliable Results"
        }
    ]

    return (
        <Layout>
            <div className={css.heroContainer}>
                <div className={css.heroContent}>
                    <img src={Logo} alt="logo" className={css.heroLogo} />
                    <div className={css.heroText}>
                        <h4>EXCLUSIVE RELEASES</h4>
                        <div className={css.line} />
                        <h1>High-Performance Antibodies and Conjugates — <span>Developed, Validated, and Released Exclusively Though Identifyn®</span> Before Broader Distribution</h1>
                    </div>
                    <div className={css.logoContainer}>
                        {logos.map((item) => {
                            return (
                                <div className={css.logo}>
                                    <img src={item.icon} alt={item.text} />
                                    <p>{item.text}</p>
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            </div>
            <div className={`${css.section} ${selectedProduct ? css.showProduct : css.hideProduct}`}>
                <div className={css.selectionContainer}>
                    <div className={css.listContainer}>
                        <div className={css.filtersContainer}>
                            {tabs.map((item) => {
                                return <button key={item.value} onClick={() => {
                                    setActiveTab(item.value)
                                }}
                                    className={`${css.tab} ${activeTab === item.value ? css.activeTab : ''}`}
                                >{item.label}</button>
                            })
                            }
                        </div>
                        <div className={css.divider} />
                        <ProductList products={products[activeTab]} setSelectedProduct={setProductId} maxHeight={width > 750 ? '862px' : '500px'} />
                    </div>
                </div>
                <div className={css.productContainer}>
                <ProductDetails selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} setProductId={setProductId} setModalName={setModalName} setOpenMethodologyModal={setOpenMethodologyModal} />
                </div>
            </div>
            {openMethodologyModal && <MethodologyModal setOpenMethodologyModal={setOpenMethodologyModal} selectedProduct={selectedProduct} modalName={modalName} setModalName={setModalName} />}
        </Layout>
    )
}